import { alpha, createTheme } from "@mui/material/styles";

export const drawerWidth = 288;
export const collapsedDrawerWidth = 92;
export const sidebarTransitionMs = 180;
export const sidebarMotion = `${sidebarTransitionMs}ms cubic-bezier(0.4, 0, 0.2, 1)`;
export const themeStorageKey = "ota-admin-theme";

export const brand = {
  navy: "#011540",
  blue: "#0E63BE",
  charcoal: "#2B2B2A",
  white: "#FFFFFF",
  cobalt: "#0A3D86",
  sky: "#6AA8E5",
  mist: "#EEF4FA",
  paleBlue: "#D9E8F7",
};

export const brandAssets = {
  light: {
    logoHorizontal: "/admin/static/branding/Tryakshak_Logo_hori_nbg.png",
    logoSymbol: "/admin/static/branding/Tryakshak_Logo_sym_nbg.png",
    logoVertical: "/admin/static/branding/Tryakshak_Logo_vert_nbg.png",
  },
  dark: {
    logoHorizontal: "/admin/static/branding/Tryakshak_Logo_hori_ivory_nbg.png",
    logoSymbol: "/admin/static/branding/Tryakshak_Logo_sym_ivory_nbg.png",
    logoVertical: "/admin/static/branding/Tryakshak_Logo_vert_ivory_nbg.png",
  },
};

export const emptyDevice = { id: "", secret: "", model: "", package: "", arch: "", current_version: "", target_version: "" };
export const emptyBulkTarget = { package: "", model: "", target_version: "" };

export function createAppTheme(mode) {
  const isDark = mode === "dark";
  const surfaceBorder = isDark ? alpha(brand.blue, 0.22) : alpha(brand.navy, 0.1);

  return createTheme({
    palette: {
      mode,
      primary: { main: brand.blue, dark: brand.cobalt, light: brand.sky },
      secondary: { main: isDark ? brand.sky : brand.navy },
      background: { default: isDark ? "#030D24" : "#F4F8FC", paper: isDark ? "#091733" : brand.white },
      success: { main: "#1FA971" }, warning: { main: "#D4922E" }, error: { main: "#D95C69" },
      info: { main: isDark ? brand.sky : brand.cobalt },
      text: { primary: isDark ? "#F7FAFF" : "#172033", secondary: isDark ? "rgba(223,233,247,0.72)" : "rgba(23,32,51,0.66)" },
      divider: surfaceBorder,
    },
    shape: { borderRadius: 6 },
    typography: { fontFamily: '"IBM Plex Sans", "Segoe UI", "Helvetica Neue", sans-serif', h3: { fontWeight: 700, letterSpacing: "-0.03em" }, h4: { fontWeight: 700, letterSpacing: "-0.02em" }, h5: { fontWeight: 700 }, h6: { fontWeight: 600 }, button: { textTransform: "none", fontWeight: 600 } },
    components: {
      MuiCssBaseline: { styleOverrides: { body: { background: isDark ? `radial-gradient(circle at top left, ${alpha(brand.blue, 0.26)} 0%, transparent 24%), radial-gradient(circle at 82% 14%, ${alpha(brand.sky, 0.16)} 0%, transparent 28%), linear-gradient(180deg, #020A1D 0%, #04102B 46%, #030D24 100%)` : `radial-gradient(circle at top left, ${alpha(brand.blue, 0.16)} 0%, transparent 24%), radial-gradient(circle at 88% 12%, ${alpha(brand.paleBlue, 0.58)} 0%, transparent 26%), linear-gradient(180deg, #FBFDFF 0%, #F2F7FC 46%, #EAF1F8 100%)` } } },
      MuiPaper: { styleOverrides: { root: { backgroundImage: "none", backdropFilter: "blur(18px)" } } },
      MuiCard: { styleOverrides: { root: { backgroundImage: "none", border: `1px solid ${surfaceBorder}`, boxShadow: isDark ? "0 18px 45px rgba(0,0,0,0.26)" : "0 20px 48px rgba(1, 21, 64, 0.09)" } } },
      MuiDrawer: { styleOverrides: { paper: { borderRight: `1px solid ${surfaceBorder}`, background: isDark ? "linear-gradient(180deg, rgba(4,16,43,0.985), rgba(3,13,36,0.985))" : "linear-gradient(180deg, rgba(255,255,255,0.985), rgba(238,244,250,0.985))" } } },
      MuiButton: { styleOverrides: { root: { borderRadius: 999 }, contained: { boxShadow: isDark ? "0 12px 28px rgba(14,99,190,0.22)" : "0 12px 28px rgba(14,99,190,0.18)" }, outlined: { borderColor: alpha(brand.blue, isDark ? 0.5 : 0.28) } } },
      MuiChip: { styleOverrides: { root: { borderRadius: 999 } } },
      MuiListItemButton: { styleOverrides: { root: { "&.Mui-selected": { backgroundColor: alpha(brand.blue, isDark ? 0.18 : 0.1) }, "&.Mui-selected:hover": { backgroundColor: alpha(brand.blue, isDark ? 0.24 : 0.14) } } } },
      MuiTableCell: { styleOverrides: { head: { color: isDark ? "rgba(226, 232, 240, 0.72)" : "rgba(1, 21, 64, 0.72)", borderBottom: `1px solid ${alpha(isDark ? brand.sky : brand.navy, isDark ? 0.18 : 0.08)}`, textTransform: "uppercase", fontSize: "0.72rem", letterSpacing: "0.08em" }, body: { borderBottom: `1px solid ${alpha(isDark ? brand.sky : brand.navy, isDark ? 0.08 : 0.06)}` } } },
    },
  });
}
